import { Link } from "@mui/material";
import React from "react";
import styles from "../components/laymanComp_css/LaymanPage30.module.css";

export default function LaymanPage30() {
  return (
    <>
      <div className={styles.layman_block_2}>
        <div className={styles.block1_main_wrpr}>
          <div className={styles.block1_main_bg}>
            <div className={styles.common_width_1}>
              <div
                className={`${styles.countDiv} ${styles.titleblock} ${styles.withsubtitle}`}
              >
                <div className={styles.column}>
                  <div className={`${styles.col12} ${styles.bgifive}`}>
                    <h1>ARCHETYPE OF TAURUS</h1>
                  </div>
                </div>
              </div>
            </div>

            <div className={styles.common_width}>
              <div className={styles.layman_taurus_block_main}>
                <div
                  className={`${styles.taurus_block1_wrpr} ${styles.flex} ${styles.cmmn_mrgn}`}
                >
                  <div className={styles.layman_img_box_wrpr}>
                    {/* <img
                      className={styles.taurus_img1}
                      src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/Layman-Symbolism/layman_page_archetype_of_taurus/taurus_block1_img.webp"
                    /> */}
                    <img
                      className={styles.taurus_img1}
                      src={`${process.env.cloud_url}Layman-Symbolism/layman_page_archetype_of_taurus/taurus_block1_img.webp`}
                    />
                  </div>

                  <div className={styles.layman_txt_box_wrpr}>
                    <div className={styles.layman_txt_box_innr}>
                      <div className={styles.yellow_box_heading}>
                        <h1>
                          Taurus: Cultivating Strength and Staying Power in the
                          Cosmic Fields
                        </h1>
                      </div>

                      <p>
                        Taurus, a cosmic archetype deeply embedded within <Link href="https://www.divineinfinitebeing.com">the
                        School of Divine Infinite Being</Link> method and{" "}
                          Archetypal Astrology, emerges as a Fixed Earth Influence, the embodiment of
                        stability and the hidden force behind the foundations of
                        empires throughout history. Beyond its astrological
                        significance, Taurus, symbolized by the Bull, is a
                        powerful yet domesticated force that finds worth in the
                        simple pleasures of ascetic living and the diligent toil
                        of hard work.
                      </p>

                      <p>
                        As a{" "} Fixed Earth sign, 
                        Taurus stands as the most stabilizing force among the{" "}
                        zodiac signs.{" "} The Bull, a symbol of strength, power, and tenacity,
                        centralizes its influence in repetitious effort and the
                        development of solid, healthy habits. Taurus encourages
                        individuals to build not only physical strength but also
                        strength in reserve, fostering resilience in the face of
                        life's challenges.
                      </p>

                      <p>
                        Historically, the stabilizing influence of Taurus can be
                        observed in the Stoic practices of Roman Emperor Marcus
                        Aurelius and the disciplined, simple life embraced by
                        Taoist Masters in the East. Both traditions emphasize
                        the importance of repetition, habit, and the diligent
                        pursuit of stability as foundations for personal and
                        spiritual growth.
                      </p>
                    </div>
                  </div>
                </div>

                <div
                  className={`${styles.taurus_block2_wrpr} ${styles.flex} ${styles.cmmn_mrgn}`}
                >
                  <div className={styles.layman_img_box_wrpr}>
                    {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/Layman-Symbolism/layman_page_archetype_of_taurus/taurus_block2_img.webp" /> */}
                    <img
                      src={`${process.env.cloud_url}Layman-Symbolism/layman_page_archetype_of_taurus/taurus_block2_img.webp`}
                    />
                  </div>

                  <div className={styles.layman_txt_box_wrpr}>
                    <div className={styles.layman_txt_box_innr}>
                      <p>
                        In the Thoth Tarot, Taurus is represented by{" "}
                        <span><i>"The Hierophant"</i></span>, symbolizing the spiritual
                        teacher. The Hierophant, with an almost sinister nature
                        on the card, teaches a fundamental lesson found in all
                        systems of{" "} spiritual progression—repetition{" "}
                        and habit over an exhaustive period lead to the desired
                        results. The teacher, much like the Bull plowing a field
                        row by row season after season, pushes individuals to
                        grow strong, stable, and steady.
                      </p>

                      <p>
                        Taurus, ruled by Venus, brings forth the master's hand
                        of discipline, guiding individuals to understand that
                        results stem from the love of work. This love of work,
                        in turn, leads to the strength in one's journey,
                        emphasizing the interconnectedness of discipline,
                        progress, and the appreciation of the journey itself.
                      </p>

                      <p>
                        To work under the influence of{" "} Taurus is to
                        seek deep stabilization, feeling the weight of history
                        and civilization as a base to build from. It is an
                        invitation to accept one's place and work tirelessly to
                        defend the simple pleasures afforded by a domesticated
                        and ascetic life. Seeking the teacher and yoking oneself
                        in disciplined, step-by-step effort becomes a path to
                        discovering rooted inner strength and the staying power
                        needed for progress.
                      </p>

                      <p>
                          In conclusion, Taurus, with its cosmic influence, 
                          invites individuals to cultivate strength, resilience,
                        and staying power in the fields of life. As seekers
                        embrace the archetypal instinct of Taurus, they embark
                        on a journey of disciplined effort, rooted stability,
                        and a profound connection with the simple pleasures that
                        define a life well-lived.
                      </p>
                    </div>
                  </div>
                </div>

                <div
                  className={`${styles.taurus_block3_wrpr} ${styles.flex} ${styles.cmmn_mrgn}`}
                >
                  <div className={styles.layman_img_box_wrpr}>
                    {/* <img
                      className={styles.taurus_img1}
                      src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/Layman-Symbolism/layman_page_archetype_of_taurus/taurus_block3_img.webp"
                    /> */}
                    <img
                      className={styles.taurus_img1}
                      src={`${process.env.cloud_url}Layman-Symbolism/layman_page_archetype_of_taurus/taurus_block3_img.webp`}
                    />
                  </div>

                  <div
                    className={`${styles.layman_txt_box_wrpr} ${styles.bullet_cont}`}
                  >
                    <div className={styles.layman_txt_box_innr}>
                      <div className={styles.yellow_box_heading}>
                        <h1>Astrological Features:</h1>
                      </div>

                      <p>
                        <b>Cosmic Archetype:</b> Taurus is a potent{" "} Cosmic Archetype{" "}
                        within <Link href="https://www.divineinfinitebeing.com">the School of Divine Infinite Being</Link> method and
                        Archetypal Astrology, representing a{" "} Fixed Earth{" "}
                        Influence.
                      </p>

                      <p>
                        <b>Fixed Earth Influence:</b> Taurus is characterized by
                        its Fixed Earth nature,{" "}
                          symbolizing stability, groundedness,{" "}
                        and enduring strength.
                      </p>

                      <p>
                        <b>Symbol of the Bull:</b> Taurus is symbolized by the
                        Bull,{" "} embodying power, tenacity, and the disciplined pursuit of goals.
                      </p>

                      <p>
                        <b>Simple Pleasures and Ascetic Living:</b> Taurus finds
                        worth in the simple pleasures of ascetic living and the
                        satisfaction derived from diligent, hard work.
                      </p>

                      <p>
                        <b>Domesticated Power:</b> Taurus represents a powerful
                        force that is domesticated, emphasizing controlled
                        strength and the ability to{" "}
                          harness one's energy.
                      </p>

                      <p>
                        <b>Stabilizing Empires Throughout History:</b> The{" "}
                          stabilizing influence{" "}
                        of Taurus can be observed throughout history, playing a
                        hidden role in the foundations of empires.
                      </p>

                      <p>
                        <b>Repetitious Effort:</b> Taurus centralizes its
                        influence in repetitious effort, encouraging individuals
                        to cultivate solid, healthy habits and build strength.
                      </p>
                    </div>
                  </div>
                </div>

                <div
                  className={`${styles.taurus_block4_wrpr} ${styles.flex} ${styles.cmmn_mrgn}`}
                >
                  <div className={styles.layman_img_box_wrpr}>
                    {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/Layman-Symbolism/layman_page_archetype_of_taurus/taurus_block4_img.webp" /> */}
                    <img
                      src={`${process.env.cloud_url}Layman-Symbolism/layman_page_archetype_of_taurus/taurus_block4_img.webp`}
                    />
                  </div>

                  <div
                    className={`${styles.layman_txt_box_wrpr} ${styles.bullet_cont}`}
                  >
                    <div className={styles.layman_txt_box_innr}>
                      <p>
                        <b>Thoth Arcana - The Hierophant :</b> In the Thoth
                        Tarot, Taurus is associated with{" "}
                        <span><i>"The Hierophant,"</i></span> symbolizing the spiritual
                        teacher who imparts the fundamental lesson of repetition
                        and habit leading to desired results.
                      </p>

                      <p>
                        <b>Disciplined, Simple Life:</b> Taurus's stabilizing
                        influence is reflected in traditions such as{" "}
                          Stoicism and Taoism, where disciplined, simple living is embraced for personal and spiritual
                        growth.
                      </p>

                      <p>
                        <b>Strength in Reserve:</b> Taurus encourages
                        individuals to build not only physical strength but also
                        strength in reserve, fostering resilience in the face of
                        life's challenges.
                      </p>

                      <p>
                        <b>Venus Rulership:</b> Ruled by Venus, Taurus brings
                        forth the master's hand of discipline, emphasizing that
                        results come from the love of work, leading to strength
                        in one's journey.
                      </p>

                      <p>
                        <b>Historical Associations:</b> Taurus is linked to
                        historical figures such as Roman Emperor Marcus Aurelius
                        and Taoist Masters, showcasing the enduring influence of
                        disciplined living and stability.
                      </p>

                      <p>
                        <b>Defending Simple Pleasures:</b> Working under the
                        influence of Taurus involves defending the simple
                        pleasures afforded by a domesticated and ascetic life.
                      </p>

                      <p>
                        <b>Deep Stabilization:</b> Taurus encourages individuals
                        to seek deep stabilization, feeling the weight of
                        history and civilization as a base to build from.
                      </p>

                      <p>
                        <b>Yoking in Discipline:</b>{" "}
                          Seeking the teacher and yoking oneself in disciplined,{" "}
                        step-by-step effort becomes a path to discovering rooted
                        inner strength and staying power needed for progress.
                      </p>
                    </div>
                  </div>
                </div>

                <div className={styles.green_sec_cmn_main_wrp}>
                 
                    <Link href="/rota-the-wheel">
                      <div className={styles.green_sec_cmn_sub_wrp}>
                        <h1>
                          The Astrological Tarot association for Taurus is{" "}
                          <br />
                          The Hierophant. See our alchemical ROTA here
                        </h1>
                      </div>
                    </Link>
                  
                </div>
              </div>
            </div>

            {/* <div className={styles.demo_image}>
              <div className={styles.block1_demo_img}>
                <img src='https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/Layman-Symbolism/layman_page_archetype_of_taurus/layman_page30_block1_demo_img.webp'></img>
              </div>

              <div className={styles.block2_demo_img}>
                <img src='https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/Layman-Symbolism/layman_page_archetype_of_taurus/layman_page30_block2_demo_img.webp'></img>
              </div>

              <div className={styles.block3_demo_img}>
                <img src='https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/Layman-Symbolism/layman_page_archetype_of_taurus/layman_page30_block3_demo_img.webp'></img>
              </div>

              <div className={styles.block4_demo_img}>
                <img src='https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/Layman-Symbolism/layman_page_archetype_of_taurus/layman_page30_block4_demo_img.webp'></img>
              </div>

              <div className={styles.block5_demo_img}>
                <img src='https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/Layman-Symbolism/layman_page_archetype_of_taurus/layman_page30_block5_demo_img.webp'></img>
                <Link className={styles.blank_link} href="/rota-the-wheel"></Link>
              </div>
            </div> */}
          </div>
        </div>
      </div>
    </>
  );
}
